<template>
    <div v-if="getUserId < 1">
        <user-login></user-login>
        <b-container class="user-form" id="user-links">
            <b-row>
                <b-col>
                    <p>{{ getLanguage.calendarText.register }} <a @click.prevent="showRegister" href="#">{{ getLanguage.calendarText.registerLink }}.</a><br>
                        {{ getLanguage.calendarText.passwordReset }} <a :href="passwordUrl" target="_blank">{{ getLanguage.calendarText.passwordResetLink }}.</a></p>
                </b-col>
            </b-row>
        </b-container>
        <user-register v-show="register"></user-register>
    </div>
    <div v-else>
        <b-container class="user-form">
            <p><a @click.prevent="userLogout" href="#" class="btn btn-primary">Logout</a></p>
            <h2>{{ getLanguage.calendarText.hello }} <span class="username">{{ getUserFirstName }}</span>!</h2>
            <p>{{ getLanguage.calendarText.greeting }}</p>
            <div v-if="userIsAdmin">
                <admin-events></admin-events>
            </div>
            <div v-else>
                <user-events></user-events>
            </div>
        </b-container>
    </div>
</template>

<script>
    import UserLogin from "./UserLogin"
    import UserRegister from "./UserRegister"
    import UserEvents from "./UserEvents";
    import AdminEvents from "./AdminEvents";
    import { mapActions, mapGetters } from "vuex"
    import { BACKEND } from "../shared";

    export default {
        name: "User",
        components: { AdminEvents, UserLogin, UserRegister, UserEvents },
        data() {
            return {
                register: false,
            }
        },
        methods: {
            ...mapActions(['login', 'logout']),
            showRegister()
            {
                this.register = true;
            },
            userLogout()
            {
                this.logout();

                // reload - sonst wird manchmal nach dem logout der kalender nicht gerendert!
                location.reload();
            }
        },
        computed: {
            ...mapGetters(['getUserId', 'getUserFirstName', 'userIsAdmin', 'getLanguage']),
            passwordUrl() {
                return BACKEND + 'password/reset';
            }
        }
    }
</script>

<style scoped>

</style>